import { DataServiceBase } from "../DataServiceBase";
export class UnlockUserService extends DataServiceBase {
    constructor() {
        super('/unlock-user');
    }
    getInfoAsync(userName = null) {
        let urlQuery = userName ? `?userName=${userName}` : '';
        return this.getAsync(null, 'info' + urlQuery);
    }
}